var personMale=[
  {
    "id": 1,
    "name": "Md Ashik Mahmud",
    "img": "https://cn.bing.com/th?id=OIP.z7XO0q4QXg1_wRSpkpqXkQAAAA&pid=Api&rs=1",
    "title": "Web Designer",
    "phone": "01726-XXXXXX",
    "email": "ashik344@outlook.com",
    "site": "www.proashik.xyz",
    "dob": "Aug 6,1999",
    "address": "Bagha, Rajshahi, Bangladesh",
    "hobby1": "Gaming",
    "hobby2": "Reading book",
    "hobby3": "Cricket",
    "skill1": "python",
    "skill2": "css",
    "skill3": "html",
    "income": "35000"
  },
  {
    "id": 2,
    "name": "Md Bijoy",
    "img": "https://images.askmen.com/1080x540/grooming/appearance/maintaining-a-healthy-smile-1107367-TwoByOne.jpg",
    "title": "Web Developer",
    "phone": "01879-XXXXXX",
    "email": "mdbijoy@outlook.com",
    "site": "www.my-site.com",
    "dob": "Jun 12,1997",
    "address": "Noakhali, Bangladesh",
    "hobby1": "Movie",
    "hobby2": "Traveling",
    "hobby3": "Cricket",
    "skill1": "c",
    "skill2": "html",
    "skill3": "css",
    "income": "30000"
  },
  {
    "id": 3,
    "name": "Abdur Rahim",
    "img": "https://cn.bing.com/th?id=OIP.cL1Ef8SOGQx5qwudqtPz_wHaE7&pid=Api&rs=1",
    "title": "Web Designer",
    "phone": "01956-XXXXXX",
    "email": "abdurrahim@gmail.com",
    "site": "www.abdur-rahim.xyz",
    "dob": "Mar 22,1995",
    "address": "Dhaka, Bangladesh",
    "hobby1": "Typing",
    "hobby2": "Walking",
    "hobby3": "Gardening",
    "skill1": "c#",
    "skill2": "css",
    "skill3": "javascript",
    "income": "42000"
  },
  {
    "id": 4,
    "name": "Md Akash Uddin",
    "img": "https://cdn.pixabay.com/photo/2015/12/23/14/56/man-profile-1105761_640.jpg",
    "title": "Wev Developer",
    "phone": "01593-XXXXXX",
    "email": "mdakash1998@gmail.com",
    "site": "www.first-website.com",
    "dob": "Feb 15,1998",
    "address": "Natore, Bangladesh",
    "hobby1": "Traveling",
    "hobby2": "Gaming",
    "hobby3": "Reading story",
    "skill1": "c++",
    "skill2": "html",
    "skill3": "css",
    "income": "10000"
  },
  {
    "id": 5,
    "name": "Md Masum Ahammed",
    "img": "https://cn.bing.com/th?id=OIP.zrA3F94ahopw0PW5zBdTIgHaLH&pid=Api&rs=1",
    "title": "Student",
    "phone": "01526-XXXXXX",
    "email": "ahammed100@gmale.com",
    "site": "www.masum-ahmmed.com",
    "dob": "Mar 16,1998",
    "address": "Rajshahi, Bangladesh",
    "hobby1": "Gardening",
    "hobby2": "Reading book",
    "hobby3": "Cricket",
    "skill1": "Math",
    "skill2": "Physics",
    "skill3": "Chemistry",
    "income": "10000"
  },
  {
    "id": 6,
    "name": "Md Sajadul Islam",
    "img": "https://img.memecdn.com/god-this-is-an-handsome-man_fb_3918671.jpg",
    "title": "Banker",
    "phone": "01743-XXXXXX",
    "email": "sajadulislam@gmail.com",
    "site": "www.profile-web.xyz",
    "dob": "Aug 6,1985",
    "address": "Comilla, Bangladesh",
    "hobby1": "Bangla Natok",
    "hobby2": "Play with child",
    "hobby3": "reading poim",
    "skill1": "Math",
    "skill2": "English",
    "skill3": "Typing",
    "income": "30000"
  },
  {
    "id": 7,
    "name": "Md Sakil Ahammed",
    "img": "https://cn.bing.com/th?id=OIP.wYWhtQx2Ytbg9VOThhv1nAAAAA&pid=Api&rs=1",
    "title": "Banker",
    "phone": "01493-XXXXXX",
    "email": "mdsakil1989@outlook.com",
    "site": "www.sakil-ahammed.com",
    "dob": "Apr 11,1989",
    "address": "Shatkhira, Bangladesh",
    "hobby1": "Gaming",
    "hobby2": "Walking",
    "hobby3": "Reading book",
    "skill1": "English",
    "skill2": "Bengali",
    "skill3": "Math",
    "income": "33000"
  },
  {
    "id": 8,
    "name": "Md Saharul Islam",
    "img": "http://data.whicdn.com/images/124698065/original.jpg",
    "title": "Doctor",
    "phone": "01947-XXXXXX",
    "email": "islam6789@outlook.com",
    "site": "www.mdsaharul.me",
    "dob": "May 14,1991",
    "address": "Bogura, Bangladesh",
    "hobby1": "Play",
    "hobby2": "Reading book",
    "hobby3": "Gaming",
    "skill1": "MBBS",
    "skill2": "FCPS",
    "skill3": "Bcs",
    "income": "50000"
  },
  {
    "id": 9,
    "name": "Anik Kumar Mondol",
    "img": "https://cdn.pixabay.com/photo/2016/03/12/14/09/dream-1252041_640.jpg",
    "title": "Engineer",
    "phone": "01584-XXXXXX",
    "email": "akmondol@outlook.com",
    "site": "www.akmondol-profile.net",
    "dob": "Aug 17,1993",
    "address": "Rajshahi, Bangladesh",
    "hobby1": "Cricket",
    "hobby2": "Reading book",
    "hobby3": "Gaming",
    "skill1": "Math",
    "skill2": "Physics",
    "skill3": "English",
    "income": "43000"
  },
  {
    "id": 10,
    "name": "Md Siam Ahammed",
    "img": "https://cn.bing.com/th?id=OIP.iWfsjD5nyjAMnYxa5JzLDAHaE9&pid=Api&rs=1",
    "title": "Engineer",
    "phone": "01857-XXXXXX",
    "email": "msahammed1994@gmail.com",
    "site": "www..xyz",
    "dob": "Sep 18,1994",
    "address": "Foridpur, Bangladesh",
    "hobby1": "Play",
    "hobby2": "Reading book",
    "skill1": "Physic",
    "skill2": "Higher Math",
    "skill3": "Typing",
    "income": "39000"
  },
  {
    "id": 11,
    "name": "Najmul Mahmud",
    "img": "https://cn.bing.com/th?id=OIP.hCfHyL8u8XAbreXuaiTMQgHaHZ&pid=Api&rs=1",
    "title": "Doctor",
    "phone": "01865-XXXXXX",
    "email": "najmulmahmud1234@gmail.com",
    "site": "www.najmulmahmud1234.net",
    "dob": "Oct 19,1992",
    "address": "Natore, Bangladesh",
    "hobby1": "Play",
    "hobby2": "Gardening",
    "hobby3": "Reading book",
    "skill1": "MBBS",
    "skill2": "FCPS",
    "skill3": "BCS",
    "income": "34000"
  },
  {
    "id": 12,
    "name": "Milon Ali",
    "img": "http://wetpaint.com/wp-content/uploads/2016/07/chad-johnson-bumble-profile1.jpg",
    "title": "Doctor",
    "phone": "01688-XXXXXX",
    "email": "Mali100100@outlook.com",
    "site": "www.myprofile-melon.me",
    "dob": "Sep 18,1993",
    "address": "Bogura, Bangladesh",
    "hobby1": "Walking",
    "hobby2": "Reading book",
    "hobby3": "Traveling",
    "skill1": "MBBS",
    "skill2": "FCPS",
    "skill3": "BCS",
    "income": "41000"
  },
  {
    "id": 13,
    "name": "Guo Ren",
    "img": "https://cn.bing.com/th?id=OIP.siKu0LIqz6a4KOpSw-kHGwHaGL&pid=Api&w=960&h=800&rs=1",
    "title": "Computer Engineer Teacher",
    "phone": "+8613687XXXXXX",
    "email": "guoren123@outlook.com",
    "site": "www.proguoren123.com",
    "dob": "Sep 20,1986",
    "address": "Kunming, china",
    "hobby1": "Play",
    "hobby2": "Reading book",
    "hobby2": "programming",
    "skill1": "Programing languse",
    "skill2": "html,css",
    "skill3": "Typing",
    "income": "39000"
  },
  {
    "id": 14,
    "name": "Xi Shuang",
    "img": "https://cpb-eu-w2.wpmucdn.com/blogs.ucl.ac.uk/dist/f/290/files/2015/05/profile-pic.jpg",
    "title": "Engineer",
    "phone": "+867834XXXXXX",
    "email": "shuang@outlook.com",
    "site": "www.xi-profile.me",
    "dob": "Nov 2,1994",
    "address": "Beijing, China",
    "hobby1": "Making Machine",
    "hobby2": "Reading book",
    "hobby3": "Play",
    "skill1": "Machine Making",
    "skill2": "Higher Math",
    "skill3": "Typing",
    "income": "42000"
  },
  {
    "id": 15,
    "name": "Mark Kumar",
    "img": "http://cdn.cnn.com/cnnnext/dam/assets/170726110140-cnn-vasco-cotovio-profile-full-169.jpg",
    "title": "Doctor",
    "phone": "75978XXXXXX",
    "email": "markkumar1@gmail.com",
    "site": "www.pro-mark.net",
    "dob": "Sep 10,1992",
    "address": "Rajasthan,India",
    "hobby1": "Traveling",
    "hobby2": "Play",
    "hobby3": "Reading book",
    "skill1": "MBBS",
    "skill2": "BCS",
    "skill3": "FCPS",
    "income": "24000"
  },
  {
    "id": 16,
    "name": "Ping Tung Tung",
    "img": "https://img2.thejournal.ie/inline/2470754/original/?width=428&version=2470754",
    "title": "Engineer",
    "phone": "890728XXXXXX",
    "email": "tungtung@outlook.com",
    "site": "www.myaccount.me",
    "dob": "Dec 29,1993",
    "address": "Tokio, Japan",
    "hobby1": "Gaming",
    "hobby2": "Machine",
    "hobby3": "Reading book",
    "skill1": "Physic",
    "skill2": "Higher Math",
    "income": "37000"
  }
 
]
export default personMale;